import { useCallback, useEffect } from 'react';

import LoaderCircle, {
    LoaderCircleMode,
    DEFAULT_LOADER_DELAY,
} from '@perpay-web/components/base/LoaderCircle/LoaderCircle';
import { useTimedEvent } from '@perpay-web/hooks/useTimedEvent';
import { reportError } from '@perpay-web/utils/errorHandlers';
import { noop } from '@perpay-web/utils/noop';

const WARNING_TIMEOUT_MS = 15000; // 15 seconds

type WarningLoaderCircleProps = {
    onTimeout?: VoidFunction;
    delay?: number;
    mode?: LoaderCircleMode;
};

const WarningLoaderCircle = ({
    onTimeout = noop,
    delay = DEFAULT_LOADER_DELAY,
    mode = LoaderCircleMode.LIGHT,
}: WarningLoaderCircleProps) => {
    const timedEventCallback = useCallback(() => {
        reportError('Infinite loader');
        onTimeout();
    }, [onTimeout]);

    const { startTimer, clearTimer } = useTimedEvent(
        timedEventCallback,
        WARNING_TIMEOUT_MS,
    );

    useEffect(() => {
        startTimer();
        return () => clearTimer();
    }, [clearTimer, startTimer]);

    return <LoaderCircle delay={delay} mode={mode} />;
};

export default WarningLoaderCircle;
